<template>
    <div v-if="isAdd==1" class="el-table el-table--fit el-table--border">
        <div class="el-table__body-wrapper">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                <tbody>
                    <tr>
                        <td ref="tdlbl_调离类型" class="el-table__cell tdlbl tdw13" colspan="1">

                            <span v-field-lbl="'select90451'" class="field">调离类型</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="select90451"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：辞职\n1：退休\n2：辞退','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'调离类型','propName':'select90451','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'SELECT_90451','iconName':'xialakuang','model':'vo.passenger.select90451','option':[{'value':'0','name':'辞职'},{'name':'退休','value':'1'},{'name':'辞退','value':'2'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false,'formTdColspan':8}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                        <td ref="tdlbl_辞职/辞退/退休时间" class="el-table__cell tdlbl tdw13" colspan="1">

                            <span v-field-lbl="'transferDate'" class="field">辞退/退休时间</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="transferDate"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'辞退/退休时间','propName':'transferDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'DATE_65486','iconName':'rqxzk','model':'vo.passenger.transferDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':8}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                        <td ref="tdlbl_预计退休时间" class="el-table__cell tdlbl tdw13" colspan="1">

                            <span v-field-lbl="'expectedRetirementDate'" class="field">预计退休时间</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="expectedRetirementDate"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'预计退休时间','propName':'expectedRetirementDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'DATE_41626','iconName':'rqxzk','model':'vo.passenger.expectedRetirementDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':8}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <inner-table v-else id="innerTableRecords" ref="changeRecordsList" :listviewurl="'teacher.changeRecords.list'" :can-edit="0" :can-delete="1" :link-prop-name="'orgCode'" />
</template>

<script>
export default {
    props: {
        vo: { type: Object, default: function() { return {} } },
        isAdd: { type: Number, default: 0 }
    },
    data: function() {
        return {
            loginUser: this.$store.getters.loginUser,
            activeTabName: 'User',
            vo: {}
        }
    },
    computed: {},
    watch: {},
    created: function() {
        // if(this.$parent.$vnode.context.activeTabIndex){
        //     this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        // }

        // this.$set(this.$vnode.context,"wfAttach",false)
    },
    beforeDestroy: function() {},
    mounted: function() {},
    methods: {
    }
}
</script>

<style scoped>
    .header {
        padding: 10px 20px;
        background-color: #f2f5fb;
        font-size: 15px;
    }
</style>
